import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["hill-intervals"]!;

export function Body() {
  return (
    <>
      <p>
        Hill repeats are a classic part of distance running. They work the legs like strength
        training while you run. A study from New Zealand tested different ways of doing them.
      </p>

      <h2>What the researchers did</h2>
      <p>
        Twenty well-trained runners were randomly given one of five uphill interval programmes,
        from shorter and very hard to longer and more moderate. They trained for six weeks. Before
        and after, the researchers tested a 5 km time trial, running economy and jumping power.
      </p>

      <h2>What they found</h2>
      <p>
        The 5 km time improved by 2.0 percent on average, and there was no clear best
        programme. The hardest programme gave the largest improvement in running economy, 2.4
        percent, and in jumping power.
      </p>

      <h2>What it means for you</h2>
      <p>
        Hill intervals are a good way to train, and you don't need a precise formula. Short, hard
        hills mainly build power and economy. Longer hills at a slightly lower effort train more
        of your endurance.
      </p>
      <p>
        Uphill, pace says little about effort. Run by how hard it feels and how you breathe, and
        jog or walk down easily so you are ready for the next repetition.
      </p>

      <h2>What the study can't tell you</h2>
      <p>
        With 20 runners split between five programmes, each group was small. The study lasted six
        weeks and included well-trained runners.
      </p>

      <h2>How we use it</h2>
      <p>
        Hill sessions in PX7 Training are guided by effort, not by your flat-ground pace. Recovery
        down the hill is part of the session.
      </p>

      <h2>Source</h2>
      <ul>
        <li>
          Barnes et al. (2013), Effects of different uphill interval-training programs on running
          economy and performance.{" "}
          <a href="https://doi.org/10.1123/ijspp.8.6.639">International Journal of Sports Physiology and Performance</a>.
        </li>
      </ul>
    </>
  );
}
